import { CURRENT_CONFIG } from '/@/api/http/config'

export const AMapConfig = {
  url: CURRENT_CONFIG.amapUrl,
  key: CURRENT_CONFIG.amapKey,
  latitude: CURRENT_CONFIG.amapLatitude,
  longitude: CURRENT_CONFIG.amapLongitude,
  gridStartLatitude: CURRENT_CONFIG.amapGridStartLatitude,
  gridStartLongitude: CURRENT_CONFIG.amapGridStartLongitude,
  gridEndLatitude: CURRENT_CONFIG.amapGridEndLatitude,
  gridEndLongitude: CURRENT_CONFIG.amapGridEndLongitude,
  gridSize: CURRENT_CONFIG.amapGridSize,

  cesiumRectangleStartLongitude: CURRENT_CONFIG.amapCesiumRectangleStartLongitude,
  cesiumRectangleStartLatitude: CURRENT_CONFIG.amapCesiumRectangleStartLatitude,
  cesiumRectangleEndLongitude: CURRENT_CONFIG.amapCesiumRectangleEndLongitude,
  cesiumRectangleEndLatitude: CURRENT_CONFIG.amapCesiumRectangleEndLatitude,

  gmapKey: CURRENT_CONFIG.gmapKey,
  path: CURRENT_CONFIG.amapPath,
  version: '2.0',
  plugins: [
    'AMap.Scale',
    'AMap.ToolBar',
    'AMap.ControlBar',
    'AMap.ElasticMarker',
    'AMap.MapType',
    'AMap.Geocoder',
    'AMap.CircleEditor',
    'AMap.PolygonEditor',
    'AMap.PolylineEditor',
    'AMap.PolyEditor',
    'AMap.RangingTool',
    'AMap.Weather',
    'AMap.MouseTool',
    'AMap.MoveAnimation'
  ]
}
